export const HASH_V2_EPOCH = `2026-07-01T00:00:00Z`;
